import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import Button from "../Button/Button";
import Fi from "../Field/Fi";
import { TextField, FormGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import SuccessIcon from "../../../assets/svgs/success_icon.svg";

export default function ContactSellerModal({ open, setOpen, heading, desc }) {

  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        open={open}
        onClose={handleClose}
      >
        <Box
          sx={{
            background: "white",
            display: "flex",
            flexFlow: "column",
            rowGap: "24px",
            alignItems: "center",
            width: { xs: "327px", sm: "400px" },
            height: "258px",
            borderRadius: "8px",
            padding: "40px 24px",
            boxShadow:
              "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
          }}
        >
          <img src={SuccessIcon} width="56px" height="56px" alt="success" />
          <Typography
            sx={{ fontSize: "22px", fontWeight: "600", lineHeight: "26px" }}
          >
            {heading}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "24px",
              color: "#616161",
              width: "70%",
              textAlign: "center",
            }}
          >
            {desc}
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
